import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=16c445ec&scoped=true&"
import script from "./TextInput.vue?vue&type=script&lang=js&"
export * from "./TextInput.vue?vue&type=script&lang=js&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=16c445ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c445ec",
  null
  
)

export default component.exports